<template>
    <div class="card-block pb-5">
      <!-- Título da seção -->
      <div class="form-group row">
        <div class="col-md-10">
          <h5>
            <strong><i class="far fa-user"></i> Informações do Associado</strong>
          </h5>
        </div>
        <div class="col-md-2">
          <a
            v-if="!isBusyInfosAssociado"
            href="javascript:void(0);"
            @click="toggleBusyInfosAssociado"
          >
            <i class="fas fa-eye" style="font-size: 16px" v-b-tooltip.hover :title="'Minimizar Dados'"></i>
          </a>
          <a
            v-else
            href="javascript:void(0);"
            @click="toggleBusyInfosAssociado"
          >
            <i class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i>
          </a>
        </div>
      </div>

      <!-- Dados do Associado -->
      <div v-if="!isBusyInfosAssociado">
        <div class="associate__info__rows__container">
          <div class="row__container" style="justify-content: flex-start; gap: 1.5rem">
            <div class="row__item">
                              <i
                                :class="
                                  'fas ' +
                                    (objSelected &&
                                    checkTrueReturnBoolean(
                                      objSelected.indicadorProdutorRural,
                                      'indicadorProdutorRural'
                                    )
                                      ? 'fa-check-circle'
                                      : 'fa-times-circle')
                                "
                              ></i>
                              <p class="row__type">Produtor Rural</p>
                            </div>
                            <div class="row__item">
                              <i
                                :class="
                                  'fas ' +
                                    (objSelected &&
                                    checkTrueReturnBoolean(
                                      objSelected.mei,
                                      'mei'
                                    )
                                      ? 'fa-check-circle'
                                      : 'fa-times-circle')
                                "
                              ></i>
                              <p class="row__type">MEI</p>
                            </div>
                            <div class="row__item">
                              <i
                                :class="
                                  'fas ' +
                                    (objSelected &&
                                    checkTrueReturnBoolean(
                                      indicadorPep,
                                      'indicadorPep'
                                    )
                                      ? 'fa-check-circle'
                                      : 'fa-times-circle')
                                "
                              ></i>
                              <p class="row__type">PEP</p>
                            </div>
          </div>

          <div class="row__container">
            <p class="row__type">Vínculo Empregatício</p>
            <p class="row__description">{{ objSelected.vinculoEmpregaticio || '-' }}</p>
          </div>

          <div class="row__container">
            <p class="row__type">Descrição da Profissão</p>
            <p class="row__description">{{ objSelected.descricaoProfissao || '-' }}</p>
          </div>

          <div class="row__container">
            <p class="row__type">Atividade Econômica</p>
            <p class="row__description">{{ objSelected.atividadeEconomica || '-' }}</p>
          </div>

          <div class="row__container">
            <p class="row__type">Risco PLD</p>
            <p class="row__description">{{ nivelRiscoPld || '-' }}</p>
          </div>

          <div class="row__container">
            <p class="row__type">Descrição da Categoria</p>
            <p v-for="descCat in filteredDescricaoCategoria" :key="descCat">
            {{ descCat }}
            </p>
          </div>

          <div class="row__container">
            <p class="row__type">Descrição da Categoria Produtor Rural</p>
            <p class="row__description">{{ objSelected.descricaoCategoriaProdutorRural || '-' }}</p>
          </div>

          <div class="row__container" style="border: none">
            <p class="row__type">CNAE</p>
            <p class="row__description">
              {{ objSelected.codigoCnae || '' }}
              <span style="font-weight: 500"> - {{ objSelected.cnae || '' }}</span>
            </p>
          </div>

          <div class="row__container" style="border-bottom: none; border-top: solid 1px #d9d9d9; margin-top: 4rem;">
            <div class="row__item">
              <p class="row__type">Tipo de Renda:</p>
              <p class="row__description">{{ objSelected.tipoRenda || '-' }}</p>
            </div>
            <div class="row__item">
              <i @click="toggleMoneyBlur" :class="moneyBlur ? 'fas fa-eye-slash' : 'fas fa-eye'" style="cursor: pointer"></i>
              <span class="row__description" style="font-size: 1rem">R$
                <p :class="moneyBlur ? 'money__blur' : ''" style="display: inline-block">
                  {{ grossMonthlyIncome || '-' }}
                </p>
              </span>
            </div>
          </div>
        </div>

        <!-- Observações -->
        <div class="form-group row">
          <div class="col-md-12">
            <label><strong>Observações</strong></label>
            <div class="input-group">
              <b-form-textarea
                v-model="form.observacao.value"
                :placeholder="'Observações gerais do Associado'"
                :rows="form.observacao.rows"
                :size="form.observacao.maxlength"
                :noResize="form.observacao.noResize"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  props: {
    objSelected: {
      type: Object,
      default: () => ({})
    },
    indicadorPep: {
      type: String,
      default: ''
    },
    nivelRiscoPld: {
      type: String,
      default: ''
    },
    grossMonthlyIncome: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isBusyInfosAssociado: true,
      moneyBlur: true
    }
  },
  computed: {
    filteredDescricaoCategoria () {
      return Array.isArray(this.objSelected.descricaoCategoria)
        ? this.objSelected.descricaoCategoria
        : []
    }
  },
  methods: {
    toggleBusyInfosAssociado () {
      this.isBusyInfosAssociado = !this.isBusyInfosAssociado
    },
    toggleMoneyBlur () {
      this.moneyBlur = !this.moneyBlur
    },
    getIconClass (value, prop) {
      return 'fas ' + (value ? 'fa-check-circle' : 'fa-times-circle')
    },
    checkTrueReturnBoolean (value, debug) {
      let result

      if (!value) {
        // If value comes as Undefined or Null
        result = false
      } else if (isNaN(value)) {
        // If value comes as String
        result = value.toUpperCase() === 'SIM'
        // eslint-disable-next-line use-isnan
      } else if (parseInt(value) !== NaN) {
        // If value comes as number
        result = parseInt(value)
      } else if (typeof value === 'boolean') {
        // If value comes as boolean
        result = value
      } else {
        // Anything not mapped
        result = false
      }

      return result
    },
    filterArray (arr) {
      let newArr = []
      arr.forEach(int => {
        if (int > 0 && !newArr.find(numb => numb === parseInt(int))) {
          newArr.push(parseInt(int))
        }
      })
      return newArr.length ? newArr : ['-']
    }
  }
}
</script>

  <style scoped>
  .money__blur {
    color: #ccc;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateInfos.vue